import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  ReservationBookingEngine,
  ReservationBookingEngineConfig,
  ReservationBookingEngineSaveConfig,
} from "../../Services/Service";

// =========================================================
// Get Booking Engine URL
// =========================================================
export const getBookingEngineUrl = createAsyncThunk(
  "bookingEngine/getBookingEngineUrl",
  async (PID, { rejectWithValue }) => {
    try {
      const response = await ReservationBookingEngine(PID);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// =========================================================
// Get Saved Config (GET) - filters + rooms prefill
// =========================================================
export const getBookingEngineConfig = createAsyncThunk(
  "bookingEngine/getBookingEngineConfig",
  async (PID, { rejectWithValue }) => {
    try {
      const response = await ReservationBookingEngineConfig(PID);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// =========================================================
// Save Config (POST) - Submit button
// =========================================================
export const saveBookingEngineConfig = createAsyncThunk(
  "bookingEngine/saveBookingEngineConfig",
  async ({ PID, payload }, { rejectWithValue }) => {
    try {
      const response = await ReservationBookingEngineSaveConfig(PID, payload);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const bookingEngineSlice = createSlice({
  name: "bookingEngine",
  initialState: {
    bookingUrl: "",
    loading: false,
    error: null,

    config: null,
    configLoading: false,
    configError: null,

    saving: false,
    saveError: null,
    saveSuccess: false,
  },
  reducers: {
    resetSaveStatus: (state) => {
      state.saveSuccess = false;
      state.saveError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Booking URL
      .addCase(getBookingEngineUrl.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getBookingEngineUrl.fulfilled, (state, action) => {
        state.loading = false;
        state.bookingUrl = action.payload;
      })
      .addCase(getBookingEngineUrl.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get Config
      .addCase(getBookingEngineConfig.pending, (state) => {
        state.configLoading = true;
        state.configError = null;
      })
      .addCase(getBookingEngineConfig.fulfilled, (state, action) => {
        state.configLoading = false;
        state.config = action.payload; // { Success, Message, Data }
      })
      .addCase(getBookingEngineConfig.rejected, (state, action) => {
        state.configLoading = false;
        state.configError = action.payload;
      })

      // Save Config
      .addCase(saveBookingEngineConfig.pending, (state) => {
        state.saving = true;
        state.saveError = null;
        state.saveSuccess = false;
      })
      .addCase(saveBookingEngineConfig.fulfilled, (state) => {
        state.saving = false;
        state.saveSuccess = true;
      })
      .addCase(saveBookingEngineConfig.rejected, (state, action) => {
        state.saving = false;
        state.saveError = action.payload;
      });
  },
});

export const { resetSaveStatus } = bookingEngineSlice.actions;
export default bookingEngineSlice.reducer;